import $ from "jquery"
import "./scrollMonitor"
var ctMapLoaded = false;
var myElement = document.getElementById("map");

if (typeof (myElement) != 'undefined' && myElement != null) {
	// exists.

	var elementWatcher = scrollMonitor.create(myElement);

	elementWatcher.enterViewport(function () {

		if (!ctMapLoaded) {
			// ctLoadMap1();
			ctMapLoaded = true;
			//ctLoadMap3();
		}

	});
}

var ctMapApiKey = 'AIzaSyAnz8pRT5VNsE9TixenbwN0hZxTC-7Wz74';

function ctLoadMap3(){
	var div = document.getElementById("map");
	var options = {
		zoom: 12,
		center: {lat: 52.2147781, lng: 21.065138599999955},
		zoomControl: false,
		mapTypeControl: false,
		scaleControl: false,
		streetViewControl: false,
		rotateControl: false,
		fullscreenControl: false,
		styles: [
			{
				"featureType": "water",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#e9e9e9"
					},
					{
						"lightness": 17
					}
				]
			},
			{
				"featureType": "landscape",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#f5f5f5"
					},
					{
						"lightness": 20
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#ffffff"
					},
					{
						"lightness": 17
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "geometry.stroke",
				"stylers": [
					{
						"color": "#ffffff"
					},
					{
						"lightness": 29
					},
					{
						"weight": 0.2
					}
				]
			},
			{
				"featureType": "road.arterial",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#ffffff"
					},
					{
						"lightness": 18
					}
				]
			},
			{
				"featureType": "road.local",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#ffffff"
					},
					{
						"lightness": 16
					}
				]
			},
			{
				"featureType": "poi",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#f5f5f5"
					},
					{
						"lightness": 21
					}
				]
			},
			{
				"featureType": "poi.park",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#dedede"
					},
					{
						"lightness": 21
					}
				]
			},
			{
				"elementType": "labels.text.stroke",
				"stylers": [
					{
						"visibility": "on"
					},
					{
						"color": "#ffffff"
					},
					{
						"lightness": 16
					}
				]
			},
			{
				"elementType": "labels.text.fill",
				"stylers": [
					{
						"saturation": 36
					},
					{
						"color": "#333333"
					},
					{
						"lightness": 40
					}
				]
			},
			{
				"elementType": "labels.icon",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "transit",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#f2f2f2"
					},
					{
						"lightness": 19
					}
				]
			},
			{
				"featureType": "administrative",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#fefefe"
					},
					{
						"lightness": 20
					}
				]
			},
			{
				"featureType": "administrative",
				"elementType": "geometry.stroke",
				"stylers": [
					{
						"color": "#fefefe"
					},
					{
						"lightness": 17
					},
					{
						"weight": 1.2
					}
				]
			}
		]
	};
	if(div) var ourMap = new google.maps.Map(div, options);

	var projOptions = {
		position: {lat: 52.2147781, lng: 21.065138599999955},
		zoomControl: false,
		map: ourMap,
		title: "createIT",
		icon: "/wp-content/themes/createit20/assets/img/pin-marker.png",
		animation: google.maps.Animation.DROP
	};
	var marker = new google.maps.Marker(projOptions);

}

function ctLoadMap1(){
	var script = document.createElement('script');
	script.src = 'https://maps.googleapis.com/maps/api/js?key='+ ctMapApiKey + '&callback=ctLoadMap3';
	script.type = 'text/javascript';
	script.defer = true;
	document.getElementsByTagName('head')[0].appendChild(script);
}
